export default "__VITE_ASSET__1b01564c__"